import api from '../config/api';

const customerService = {
  async getAll() {
    const response = await api.get('/api/admin/customers');
    return response.data;
  },

  async search(q) {
    const response = await api.get('/api/admin/customers/search', { params: { q } });
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/api/admin/customers/${id}`);
    return response.data;
  },
};

export default customerService;
